export function gtag(...args: any[]) {
  window['dataLayer'] = window['dataLayer'] || [];
  window['dataLayer'].push(args);
}
